import { Component, OnInit, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { ListWithinList } from '../../core/models/list-within-list';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { NewPageList } from '../../core/models/new-page-list';

@Component({
  selector: 'app-sub-list',
  templateUrl: './sub-list.component.html',
  styleUrls: ['./sub-list.component.css'],
  providers: [NewPageService]
})
export class SubListComponent implements OnInit {

  @ViewChild('child', { read: ViewContainerRef }) child: ViewContainerRef;

  parent: ListWithinList;

  master: NewPageList;

  listWithinList: ListWithinList;

  eventList: boolean = true;

  _ref: any;

  customClass: string = '';

  constructor(private _cfr: ComponentFactoryResolver, private newPageService: NewPageService) {
    this.newPageService.validate$.subscribe(validate => {
      if (validate) {
        this.validate();
      }
    });
  }

  ngOnInit() {
    if (this.listWithinList.listWithinListList) {
      this.listWithinList.listWithinListList.forEach(element => {
        this.setChild(element);
      })
    } else {
      this.listWithinList.hasSubList = false;
      this.listWithinList.listWithinListList = new Array();
    }
  }

  addChild() {
    var subList = this._cfr.resolveComponentFactory(SubListComponent);
    var expComponent = this.child.createComponent(subList);
    let listWithinListData = new ListWithinList();
    listWithinListData.hasSubList = false;
    this.listWithinList.listWithinListList.push(listWithinListData);
    expComponent.instance._ref = expComponent;
    expComponent.instance.listWithinList = listWithinListData;
    expComponent.instance.parent = this.listWithinList;
    this.listWithinList.hasSubList = true;
  }

  removeChild() {
    if (this.parent) {
      this.parent.listWithinListList = this.parent.listWithinListList.filter((val, i) => i != this.parent.listWithinListList.indexOf(this.listWithinList));
      if (this.parent.listWithinListList.length == 0) {
        this.parent.hasSubList = false;
      }
    } else if (this.master) {
      this.master.listWithinListList = this.master.listWithinListList.filter((val, i) => i != this.master.listWithinListList.indexOf(this.listWithinList));
    }
    this._ref.destroy();
  }

  setChild(listWithinList: ListWithinList) {
    var subList = this._cfr.resolveComponentFactory(SubListComponent);
    var expComponent = this.child.createComponent(subList);
    expComponent.instance._ref = expComponent;
    expComponent.instance.listWithinList = listWithinList;
    expComponent.instance.parent = this.listWithinList;
  }

  isSubList() {
    if (!this.listWithinList.hasSubList) {
      this.addChild();
    } else {
      this.child.clear();
      this.listWithinList.listWithinListList = new Array();
    }
  }
  validate() {

    if (this.listWithinList.text == null || this.listWithinList.text.trim().length < 1) {
      this.customClass = 'fieldWithErrors';
    } else {
      this.customClass = '';
    }
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/sub-list/sub-list.component.ts